import HottestMoments from './hottest-moments';

export default HottestMoments;
